import { FC, PropsWithChildren, ButtonHTMLAttributes } from 'react'
import cn from 'classnames'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'contained' | 'default' | 'square'
  label?: string
}

// Theme-agnostic button used by shared SelectTicketPage components.
// Primary action colour comes from the semantic `interactive` token, mapped per theme.
const buttonVariants: Record<NonNullable<ButtonProps['variant']>, string> = {
  contained: 'text-white bg-interactive rounded-lg py-6 px-8 darken leading-none',
  default: 'darken rounded-lg',
  square:
    'bg-interactive darken flex size-9 items-center justify-center rounded-ticket-step border-none leading-none text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-interactive',
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  variant = 'default',
  className,
  label,
  ...props
}) => {
  return (
    <button
      className={cn(
        'disabled:bg-neutral-medium-lighter block not-disabled:cursor-pointer disabled:cursor-default',
        buttonVariants[variant],
        className
      )}
      {...props}
    >
      {label && <span className="flex items-baseline">{label}</span>}
      {children}
    </button>
  )
}
